import {
  FonteLiberacaoEnum,
  StatusEnum
} from '../modules/Solicitacoes/components'

export const solicitacoesStatusOptions = Object.values(StatusEnum).map(
  status => ({
    label: status,
    value: status
  })
)

export const solicitacoesAnaliseDeDocumentosOptions = [
  {
    label: 'Completa',
    value: 'false'
  },
  {
    label: 'Documentos',
    value: 'true'
  }
]

export const fonteLiberacaoOptions = [
  {
    label: 'Automaticamente',
    value: FonteLiberacaoEnum.AUTOMATICAMENTE
  },
  {
    label: 'Central de Cadastros',
    value: FonteLiberacaoEnum.CENTRAL_CADASTROS
  },
  {
    label: 'Gestor',
    value: FonteLiberacaoEnum.GESTOR
  },
  {
    label: 'Não Recomendada',
    value: FonteLiberacaoEnum.NAO_RECOMENDAR
  }
]
